module.exports = __webpack_public_path__ + "static/media/YF58_2.d36a001b.jpg";